import styled from "styled-components";

export const ShellContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;

export const ShellContent = styled.main`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const ShellRoutes = styled.div`
    flex: 1;
    background: #fff;
    overflow-x: auto;
    padding-top: 50px;

    .alert-enter {
        opacity: 0;
        transform: scale(0.9);
    }
    .alert-enter-active {
        opacity: 1;
        transform: translateX(0);
        transition: opacity 200ms, transform 200ms;
    }
    .alert-exit {
        opacity: 1;
    }
    .alert-exit-active {
        opacity: 0;
        transform: scale(0.9);
        transition: opacity 200ms, transform 200ms;
    }
`;
